import { createFolder } from 'api/folders';

export const createDefaultClientFolder = async (
  organizationId,
  user,
  locale,
) => {
  if (!organizationId || !user) {
    return Promise.resolve(null);
  }

  const newFolderData = await createFolder({
    name: user.lastName,
    travelers: [],
    locale: locale || undefined,
  });
  return newFolderData.data;
};
